import getInfoBarMessageIdsInCompose from './getInfoBarMessageIdsInCompose';
import addInfoBarMessage from '../actions/addInfoBarMessage';
import removeInfoBarMessage from '../actions/removeInfoBarMessage';
var infoBarAddHandler = function (viewState) { return function (messageId, infoBarMessageViewStateCreator) {
    addInfoBarMessage(viewState, messageId, infoBarMessageViewStateCreator);
}; };
var infoBarRemoveHandler = function (viewState) { return function (messageIds) {
    removeInfoBarMessage(viewState, messageIds);
}; };
var infoBarGetIdsHandler = function (viewState) { return function () {
    return getInfoBarMessageIdsInCompose(viewState);
}; };
export { infoBarAddHandler, infoBarRemoveHandler, infoBarGetIdsHandler };
//# sourceMappingURL=infoBarHandlers.js.map